import styled from "styled-components";

import StatusValue from "./StatusValue.styled";

const StyledStatusLine = styled.div`
  display: flex;
  align-items: center;

  ${StatusValue} {
    margin: 0 8px;
  }
`;

export default StyledStatusLine;
